"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var large = _ref.large,
      small = _ref.small,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? ["False", "True"] : _ref$labels,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      props = _objectWithoutProperties(_ref, ["large", "small", "className", "labels", "value", "onChange", "disabled", "autoFocus"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasFocus = _React$useState2[0],
      setHasFocus = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      thisRef = _React$useState4[0],
      setRef = _React$useState4[1];

  _react["default"].useEffect(function () {
    Boolean(thisRef) && autoFocus && thisRef.focus();
  }, [autoFocus, thisRef]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    onClick: disabled ? null : function (e) {
      return onChange(!value);
    },
    onFocus: function onFocus(e) {
      return setHasFocus(true && !disabled);
    },
    onBlur: function onBlur(e) {
      return setHasFocus(false);
    },
    className: "\n        ".concat(large ? "".concat(theme.paddingLarge, " ").concat(theme.textLarge) : small ? "".concat(theme.paddingSmall, " ").concat(theme.textSmall) : "".concat(theme.paddingBase, " ").concat(theme.textBase), "\n        ").concat(disabled ? "".concat(theme.inputBgDisabled, " ").concat(theme.inputBorderDisabled) : hasFocus ? "".concat(theme.inputBgFocus, " ").concat(theme.inputBorderFocus) : "".concat(theme.inputBg, " ").concat(theme.inputBorder), "\n        ").concat(className, "\n      "),
    ref: (0, _utils.useSetRefs)(ref, setRef),
    tabIndex: disabled ? "-1" : "0"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-0"
  }, /*#__PURE__*/_react["default"].createElement(Slider, {
    value: value
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 ml-4"
  }, labels[+Boolean(value)])));
});

exports["default"] = _default;

var Slider = function Slider(_ref2) {
  var value = _ref2.value;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-1 h-full flex justify-center items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative h-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative w-10 h-3 rounded-lg overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 w-20 h-full ".concat(theme.accent4),
    style: {
      left: value ? "100%" : "0",
      transition: "left 0.25s"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 w-20 h-full ".concat(theme.bgInfo),
    style: {
      right: value ? "0" : "100%",
      transition: "right 0.25s"
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute h-4 w-4 rounded-lg ".concat(theme.accent2),
    style: {
      top: "50%",
      left: value ? "calc(100% - 0.625rem)" : "-0.125rem",
      transform: "translateY(-50%)",
      transition: "left 0.25s"
    }
  })));
};